import StudyPage from "@/pages/study"
import { Navigate, type RouteObject } from "react-router-dom"

const routes: RouteObject = {
  path: "study",
  element: <StudyPage />,
  children: [
    {
      path: "*",
      element: <Navigate to="study" replace />,
    },
  ],
}

export default routes
